import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"
import { PermissionProtectedRoute } from "~/router/outlets/PermissionProtectedRoute"
import { InvoicingPermissionProtectedRoute } from "./components/InvoicingPermissionProtectedRoute"

const LazyCompanyInvoicesPage = lazy(
  () => import("./pages/CompanyInvoicesPage/CompanyInvoicesPage"),
)
const LazyCompanyInvoicesBulkUploadPage = lazy(
  () => import("./pages/CompanyInvoicesBulkUploadPage/CompanyInvoicesBulkUploadPage"),
)
const LazyCompanyInvoicesBulkUploadResultsPage = lazy(
  () => import("./pages/CompanyInvoicesBulkUploadResultsPage/CompanyInvoicesBulkUploadResultsPage"),
)
const LazyCompanyCreditNotesPage = lazy(
  () => import("./pages/CompanyCreditNotesPage/CompanyCreditNotesPage"),
)

// ---- Invoices Batches ----
export const LazyCompanyInvoicesBatchEditorPage = lazy(
  () => import("./pages/CompanyInvoicesBatchEditorPage/CompanyInvoicesBatchEditorPage"),
)
const LazyCompanyInvoicesBatchesPage = lazy(
  () => import("./pages/CompanyInvoicesBatchesPage/CompanyInvoicesBatchesPage"),
)
export const LazyCompanyInvoicesBatchPage = lazy(
  () => import("./pages/CompanyInvoicesBatchPage/CompanyInvoicesBatchPage"),
)

export const companyInvoicingRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      element: <PermissionProtectedRoute permissions={["invoices"]} />,
      children: [
        {
          path: "invoices",
          children: [
            {
              path: "",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <LazyCompanyInvoicesPage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
            {
              path: "bulk-upload",
              element: (
                <InvoicingPermissionProtectedRoute
                  checkBulkCreatePaygInvoicesAllowed
                  permissions={["import_invoice"]}
                />
              ),
              children: [
                {
                  path: "",
                  element: (
                    <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                      <LazyCompanyInvoicesBulkUploadPage />
                    </LazyLoadingSuspenseWithErrorBoundary>
                  ),
                },
                {
                  path: ":jobId",
                  element: (
                    <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                      <LazyCompanyInvoicesBulkUploadResultsPage />
                    </LazyLoadingSuspenseWithErrorBoundary>
                  ),
                },
              ],
            },
            {
              path: "creditnotes",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <LazyCompanyCreditNotesPage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
          ],
        },
        {
          path: "invoices-batches",
          children: [
            {
              path: "",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <LazyCompanyInvoicesBatchesPage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
            {
              path: "new",
              element: (
                <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                  <LazyCompanyInvoicesBatchEditorPage />
                </LazyLoadingSuspenseWithErrorBoundary>
              ),
            },
            {
              path: ":invoicesBatchStrongId",
              children: [
                {
                  path: "",
                  element: (
                    <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                      <LazyCompanyInvoicesBatchPage />
                    </LazyLoadingSuspenseWithErrorBoundary>
                  ),
                },
                {
                  path: "add-invoices",
                  element: (
                    <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
                      <LazyCompanyInvoicesBatchEditorPage />
                    </LazyLoadingSuspenseWithErrorBoundary>
                  ),
                },
              ],
            },
          ],
        },
      ],
    },
  ],
  DeprecatedFullScreen: [],
}
